import React from 'react';
import { Link } from 'react-router-dom';
import { SOCIAL_LINKS, CONTACT_INFO } from '../../utils/constants';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative">
      {/* Background dengan subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bg-secondary/50 to-black/80"></div>

      <div className="relative z-10 container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="mb-8">
              <div className="flex items-center space-x-3 mb-6">
                <img
                  src="/idngold_icon.png"
                  alt="IDNGold Icon"
                  className="h-10 w-10"
                />
                <img
                  src="/idngold_text.png"
                  alt="IDNGold"
                  className="h-8 w-auto"
                />
              </div>
              <p className="text-gray-400 mb-8 leading-relaxed max-w-md">
                IDNGold brings the stability of gold to the digital economy through blockchain tokenization.
              </p>

              {/* Social Links */}
              <div className="flex space-x-4">
                <a
                  href={SOCIAL_LINKS.TWITTER}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Twitter"
                >
                  <i className="fab fa-twitter text-xl"></i>
                </a>
                <a
                  href={SOCIAL_LINKS.TELEGRAM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Telegram"
                >
                  <i className="fab fa-telegram text-xl"></i>
                </a>
                <a
                  href={SOCIAL_LINKS.DISCORD}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Discord"
                >
                  <i className="fab fa-discord text-xl"></i>
                </a>
                <a
                  href={SOCIAL_LINKS.MEDIUM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Medium"
                >
                  <i className="fab fa-medium text-xl"></i>
                </a>
              </div>

            </div>
          </div>

          {/* Essential Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 text-lg">Essential</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/buy"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  Buy IDNG
                </Link>
              </li>
              <li>
                <Link
                  to="/redemption"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  Redemption
                </Link>
              </li>
              <li>
                <Link
                  to="/tokenomics"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  Tokenomics
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 text-lg">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/compliance"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  Compliance
                </Link>
              </li>
              <li>
                <Link
                  to="/risk-disclosure"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  Risk Disclosure
                </Link>
              </li>
              <li>
                <Link
                  to="/redemption-policy"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  Redemption Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-500 text-sm">
                &copy; {currentYear} IDNGold. All rights reserved.
              </p>
              <p className="text-gray-600 text-sm mt-1">
                <a
                  href={`mailto:${CONTACT_INFO.EMAIL}`}
                  className="text-gold hover:text-gold-light transition-colors duration-300"
                >
                  {CONTACT_INFO.EMAIL}
                </a>
              </p>
            </div>
            <div className="flex space-x-6">
              <a
                href="/compliance"
                className="text-gray-600 text-sm hover:text-gold transition-colors duration-300"
              >
                Compliance
              </a>
              <a
                href="/redemption-policy"
                className="text-gray-600 text-sm hover:text-gold transition-colors duration-300"
              >
                Redemption Policy
              </a>
              <a
                href="/risk-disclosure"
                className="text-gray-600 text-sm hover:text-gold transition-colors duration-300"
              >
                Risk Disclosure
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer >
  );
};